import { InvoiceSummaryResp } from '@monetize/types/app';
import { toDateShort } from '@monetize/utils/core';
import { MFlex, MText } from '../../components/Monetize';
import { getInvoiceDaysPastDue, isInvoicePastDue } from '../../utils/invoices';

interface InvoiceDueDateCellProps {
  dueDate: InvoiceSummaryResp['dueDate'];
  status: InvoiceSummaryResp['status'];
}

export const InvoiceDueDateCell = ({
  dueDate,
  status,
}: InvoiceDueDateCellProps) => {
  if (!dueDate) {
    return null;
  }

  const now = new Date();
  if (!isInvoicePastDue({ status, dueDate }, now)) {
    return <MText lineClamp={1}>{toDateShort(dueDate)}</MText>;
  }

  const daysPastDue = getInvoiceDaysPastDue(dueDate, now);

  return (
    <MFlex direction="column">
      <MText lineClamp={1} color="tRed.base" fontWeight="500">
        {toDateShort(dueDate)}
      </MText>
      <MText color="tRed.base" fontWeight="400" lineClamp={1}>
        {`${daysPastDue} ${daysPastDue === 1 ? 'day' : 'days'} past due`}
      </MText>
    </MFlex>
  );
};
